import _ from "lodash";
import { getMemoizedLangFunction, hashString } from "Utils";
import { AVATAR_COLORS } from "Constants/colorConstants";
import { getSelectedIcon } from "UIComponents/IconSelector/modules/IconSelectorUtils";

//memoized function to get the table headers
const getTableHeaders = ({ t }) => {
  const headers = [
    {
      key: "class",
      value: t("common:class"),
      style: {
        width: "40%",
      },
    },
    {
      key: "startDate",
      value: t("common:start_date"),
      style: {
        width: "30%",
      },
    },
    {
      key: "endDate",
      value: t("common:end_date"),
      style: {
        width: "30%",
      },
    },
  ];

  return headers;
};

export const getTableHeadersMemoized = getMemoizedLangFunction(getTableHeaders);

//function to get the class avatar
export const getAvatarData = ({ id, title, profileImageData = {} }) => {
  const { url = "", icon, color: _color, acronym: _acronym } =
    profileImageData || {};

  const color = _color || AVATAR_COLORS[hashString(id) % AVATAR_COLORS.length];

  const name = _acronym ? _.join(_.split(_acronym, ""), " ") : title;

  const AvatarIcon = getSelectedIcon(icon);

  const iconType = !_.isEmpty(_acronym) ? "" : icon ? "icon" : "";

  return { url, color, name, AvatarIcon, iconType };
};
